export { App as default } from '@guiker/property-sale-main-mfe'
